<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-8"></div>
                                    <div class="col-md-1 d-flex justify-content-end align-items-center">
                                        <b-button
                                            variant="secondary"
                                            class="mr-1"
                                            @click="searchListing"
                                            :disabled="!status.list && loading"
                                            :title="$t('label.refresh')"
                                            v-b-tooltip:hover
                                        >
                                            <i class="mdi mdi-refresh"></i>
                                        </b-button>
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            right
                                            menu-class="dropdown-menu-250"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Method
                                                </label>
                                                <multiselect
                                                    v-model="methodFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="methodDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">Action</label>
                                                <multiselect
                                                    v-model="actionFilter"
                                                    track-by="value"
                                                    label="text"
                                                    placeholder="Select"
                                                    select-label="Select"
                                                    selected-label="Selected"
                                                    deselect-label="Select"
                                                    :options="actionDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">Success</label>
                                                <multiselect
                                                    v-model="successFilter"
                                                    track-by="value"
                                                    label="text"
                                                    placeholder="Select"
                                                    select-label="Select"
                                                    selected-label="Selected"
                                                    deselect-label="Select"
                                                    :options="successDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list && !loading"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(method)="data">
                                    <b-badge :variant="getMethodVariant(data.item.method)">{{ data.item.method || '--' }}</b-badge>
                                </template>
                                <template #cell(success)="data">
                                    <b-badge :variant="data.item.success ? 'success' : 'secondary'">
                                        {{ data.item.success ? $t('label.yes') : $t('label.no') }}
                                    </b-badge>
                                </template>
                                <template #cell(durationMs)="data">
                                    <span>{{ data.item.durationMs != null ? `${data.item.durationMs} ms` : '--' }}</span>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        :class="[data.item.requestLog ? 'text-warning' : 'text-secondary']"
                                        v-b-tooltip.hover
                                        :title="$t('module.requestLog')"
                                        v-on:click="data.item.requestLog ? openRequestLog(data.item) : ''"
                                    >
                                        <i class="mdi mdi-web font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="$t('label.detail')"
                                        v-on:click="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-eye font-size-18"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list && !loading"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="servedeck-log-form"
            :title="$t('label.viewX', ['Servedeck Log'])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <ServedeckLogForm
                    :servedeckLog="servedeckLog"
                    @done="closeForm"
                    ref="servedeckLogForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="servedeck-request-log-form"
            :title="$t('label.viewX', [$t('module.requestLog')])"
            @hidden="closeRequestLog"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <RequestLogForm
                    :requestLog="requestLog"
                    @done="closeRequestLog"
                    ref="requestLogForm"
                />
            </b-container>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { servedeckLogMethods } from "@/state/api";
import { SERVEDECK_LOG_MODULE } from "@/state/api/servedeckLog.state";
import ServedeckLogForm from "@/views/pages/admin/diagnostic/servedeckLog/servedeckLogForm";
import RequestLogForm from "@/views/pages/admin/diagnostic/requestLog/requestLogForm";

export default {
    components: { Multiselect, ServedeckLogForm, RequestLogForm },
    created() {
        sessionHelper.clearSearch(SESSION.SERVEDECK_LOG_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();

        this.loading = false;
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            methodDdl: [
                ddlHelper.getOptionAll(),
                { value: 'GET', text: 'GET' },
                { value: 'POST', text: 'POST' },
                { value: 'PUT', text: 'PUT' },
                { value: 'PATCH', text: 'PATCH' },
                { value: 'DELETE', text: 'DELETE' },
            ],
            methodFilter: ddlHelper.getOptionAll(),
            actionDdl: [
                ddlHelper.getOptionAll(),
                { value: 'auth', text: 'auth' },
                { value: 'create', text: 'create' },
                { value: 'show', text: 'show' },
                { value: 'delete', text: 'delete' },
            ],
            actionFilter: ddlHelper.getOptionAll(),
            successDdl: [
                ddlHelper.getOptionAll(),
                { value: 1, text: i18n.t('label.yes') },
                { value: 0, text: i18n.t('label.no') },
            ],
            successFilter: ddlHelper.getOptionAll(),
            fields: [
                { key: 'createdAt', label: i18n.t("label.createdAt"), sortable: true, class: 'text-nowrap' },
                { key: 'method', label: 'Method', sortable: true, class: 'text-nowrap' },
                { key: 'action', label: 'Action', sortable: true, class: 'text-nowrap' },
                { key: 'url', label: 'URL', sortable: true },
                { key: 'statusCode', label: 'Status Code', sortable: true, class: 'text-nowrap' },
                { key: 'success', label: 'Success', sortable: true, class: 'text-nowrap' },
                { key: 'durationMs', label: 'Duration', sortable: true, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            searchCriteria: {},
            servedeckLog: this.defaultServedeckLog(),
            requestLog: this.defaultRequestLog(),
            loading: true,
        };
    },
    methods: {
        ...servedeckLogMethods,
        defaultRequestLog() {
            return {
                uuid: "",
                method: "",
                path: "",
                files: null,
                requestPayload: null,
                responsePayload: null,
                ip: "",
                url: "",
                scheme: "",
                host: "",
                port: "",
                cookies: null,
                userAgent: "",
                statusCode: "",
                success: false,
                performance: null,
                createdAt: "",
                updatedAt: "",
                user: null,
                errorLog: null,
            };
        },
        defaultServedeckLog() {
            return {
                uuid: "",
                method: "",
                action: "",
                url: "",
                requestPayload: null,
                responsePayload: null,
                errorMessage: "",
                statusCode: null,
                success: false,
                durationMs: null,
                createdAt: "",
                updatedAt: "",
                requestLog: null,
            };
        },
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.SERVEDECK_LOG_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.SERVEDECK_LOG_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    searchValue: "",
                    searchArray: [],
                };
            }
            this.getServedeckLogList(this.searchCriteria);
        },
        getServedeckLogList(filter) {
            this.getAllServedeckLog({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.SERVEDECK_LOG_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            this.currentPage = pageNumber;
            let filter = sessionHelper.retrieveSearch(SESSION.SERVEDECK_LOG_SEARCH);
            filter.pageNumber = pageNumber;
            this.getServedeckLogList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            if (this.methodFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.method;
            else if (this.methodFilter?.value != null)
                this.searchCriteria.method = this.methodFilter.value;

            if (this.actionFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.action;
            else if (this.actionFilter?.value != null)
                this.searchCriteria.action = this.actionFilter.value;

            if (this.successFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.success;
            else if (this.successFilter?.value != null)
                this.searchCriteria.success = this.successFilter.value;

            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getServedeckLogList(this.searchCriteria);
        },
        openForm(data) {
            if (data?.uuid) {
                this.servedeckLog = {
                    ...this.defaultServedeckLog(),
                    ...data,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('servedeck-log-form');
            });
        },
        closeForm() {
            this.servedeckLog = this.defaultServedeckLog();
            this.$bvModal.hide('servedeck-log-form');
        },
        openRequestLog(data) {
            if (data?.requestLog) {
                this.requestLog = {
                    ...this.defaultRequestLog(),
                    ...data.requestLog,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('servedeck-request-log-form');
            });
        },
        closeRequestLog() {
            this.requestLog = this.defaultRequestLog();
            this.$bvModal.hide('servedeck-request-log-form');
        },
        getMethodVariant(method) {
            if (method == 'GET') return 'info';
            if (method == 'POST') return 'success';
            if (method == 'PUT' || method == 'PATCH') return 'warning';
            if (method == 'DELETE') return 'danger';
            return 'secondary';
        },
    },
    computed: {
        ...mapState(SERVEDECK_LOG_MODULE, ['status']),
        tableRows() {
            return this.$store.state.api.servedeckLog.list.data || [];
        },
        totalPage() {
            return this.$store.state.api.servedeckLog.list.pagination.total || 0;
        },
    },
}
</script>
